import { useRef, useEffect, useCallback } from 'react'
import { useDesktopStore } from '@/stores/desktopStore'
import './ControlWindow.css'

// Exact icon patterns from codepen-control
const COLS = 15
const ROWS = 30

const sunIcon = [
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
]

const volumeIcon = [
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
]

export function ControlWindow() {
  const { theme, setBrightness, setVolume } = useDesktopStore()
  const brightnessCanvasRef = useRef<HTMLCanvasElement>(null)
  const volumeCanvasRef = useRef<HTMLCanvasElement>(null)
  const brightnessControlRef = useRef<HTMLDivElement>(null)
  const volumeControlRef = useRef<HTMLDivElement>(null)

  const setupCanvas = useCallback((canvas: HTMLCanvasElement) => {
    const rect = canvas.parentElement?.getBoundingClientRect()
    if (!rect) return null
    const dpr = window.devicePixelRatio || 1
    canvas.width = rect.width * dpr
    canvas.height = rect.height * dpr
    const ctx = canvas.getContext('2d')
    if (ctx) ctx.scale(dpr, dpr)
    return ctx
  }, [])

  const drawControl = useCallback((
    canvas: HTMLCanvasElement | null,
    value: number,
    maxValue: number,
    icon: number[][]
  ) => {
    if (!canvas) return
    const ctx = setupCanvas(canvas)
    if (!ctx) return

    const rect = canvas.parentElement?.getBoundingClientRect()
    if (!rect) return

    const width = rect.width
    const height = rect.height

    ctx.clearRect(0, 0, width, height)

    const cellWidth = width / COLS
    const cellHeight = height / ROWS
    const dotRadius = Math.min(cellWidth, cellHeight) * 0.3

    const fillPercentage = value / maxValue
    const fillHeight = height * fillPercentage

    // Colors matching the source
    const bgColor = theme.isDark ? '#333' : '#222'
    const fgColor = theme.isDark ? '#ffffff' : '#fff'

    for (let row = 0; row < ROWS; row++) {
      for (let col = 0; col < COLS; col++) {
        const x = col * cellWidth + cellWidth / 2
        const y = row * cellHeight + cellHeight / 2

        // Check if position is part of icon
        let isIcon = false
        const iconRows = icon.length
        const iconCols = icon[0].length
        const iconStartRow = Math.floor(ROWS * 0.6) - Math.floor(iconRows / 2)
        const iconStartCol = Math.floor((COLS - iconCols) / 2)

        if (
          row >= iconStartRow &&
          row < iconStartRow + iconRows &&
          col >= iconStartCol &&
          col < iconStartCol + iconCols
        ) {
          const iconRow = row - iconStartRow
          const iconCol = col - iconStartCol
          if (iconRow < iconRows && iconCol < iconCols && icon[iconRow][iconCol] === 1) {
            isIcon = true
          }
        }

        const dotBottom = height - y
        const isFilled = dotBottom <= fillHeight

        ctx.beginPath()
        ctx.arc(x, y, isIcon ? dotRadius * 1.1 : dotRadius, 0, Math.PI * 2)

        if (isIcon) {
          ctx.fillStyle = isFilled ? bgColor : fgColor
        } else {
          ctx.fillStyle = isFilled ? fgColor : bgColor
        }
        ctx.fill()
      }
    }
  }, [theme.isDark, setupCanvas])

  useEffect(() => {
    drawControl(brightnessCanvasRef.current, theme.brightness, 100, sunIcon)
    drawControl(volumeCanvasRef.current, theme.volume, 100, volumeIcon)
  }, [theme.brightness, theme.volume, drawControl])

  useEffect(() => {
    const handleResize = () => {
      drawControl(brightnessCanvasRef.current, theme.brightness, 100, sunIcon)
      drawControl(volumeCanvasRef.current, theme.volume, 100, volumeIcon)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [theme.brightness, theme.volume, drawControl])

  const setupDragHandling = useCallback((
    controlElement: HTMLDivElement | null,
    updateValue: (percentage: number) => void
  ) => {
    if (!controlElement) return () => {}

    let isDragging = false

    const updateFromPosition = (e: MouseEvent | TouchEvent) => {
      const rect = controlElement.getBoundingClientRect()
      let clientY: number
      if ('touches' in e) {
        clientY = e.touches[0].clientY
      } else {
        clientY = e.clientY
      }
      const posY = rect.bottom - clientY
      const percentage = Math.max(0, Math.min(1, posY / rect.height))
      updateValue(percentage)
    }

    const startDrag = (e: MouseEvent | TouchEvent) => {
      e.preventDefault()
      isDragging = true
      updateFromPosition(e)
      document.addEventListener('mousemove', drag)
      document.addEventListener('touchmove', drag, { passive: false })
      document.addEventListener('mouseup', endDrag)
      document.addEventListener('touchend', endDrag)
    }

    const drag = (e: MouseEvent | TouchEvent) => {
      if (!isDragging) return
      e.preventDefault()
      updateFromPosition(e)
    }

    const endDrag = () => {
      isDragging = false
      document.removeEventListener('mousemove', drag)
      document.removeEventListener('touchmove', drag)
      document.removeEventListener('mouseup', endDrag)
      document.removeEventListener('touchend', endDrag)
    }

    controlElement.addEventListener('mousedown', startDrag as EventListener)
    controlElement.addEventListener('touchstart', startDrag as EventListener, { passive: false })

    return () => {
      controlElement.removeEventListener('mousedown', startDrag as EventListener)
      controlElement.removeEventListener('touchstart', startDrag as EventListener)
    }
  }, [])

  useEffect(() => {
    const cleanupBrightness = setupDragHandling(brightnessControlRef.current, (percentage) => {
      setBrightness(Math.round(percentage * 100))
    })
    const cleanupVolume = setupDragHandling(volumeControlRef.current, (percentage) => {
      setVolume(Math.round(percentage * 100))
    })
    return () => {
      cleanupBrightness()
      cleanupVolume()
    }
  }, [setupDragHandling, setBrightness, setVolume])

  return (
    <div className={`control-panel ${theme.isDark ? 'dark' : 'light'}`} data-theme={theme.isDark ? 'dark' : 'light'}>
      {/* Dotted grid background - exact from source */}
      <svg className="control-panel__grid" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="dottedGridControl" width="30" height="30" patternUnits="userSpaceOnUse">
            <circle cx="2" cy="2" r="1" fill="var(--bg-pattern-color)" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#dottedGridControl)" />
      </svg>

      <main className="control-panel__main">
        <div className="control-panel__grid-controls">
          {/* Brightness Control */}
          <div className="control-container">
            <div className="dot-control" ref={brightnessControlRef}>
              <canvas ref={brightnessCanvasRef} />
            </div>
            <div className="control-label">Brightness</div>
            <div className="control-value">{theme.brightness}%</div>
          </div>

          {/* Volume Control */}
          <div className="control-container">
            <div className="dot-control" ref={volumeControlRef}>
              <canvas ref={volumeCanvasRef} />
            </div>
            <div className="control-label">Volume</div>
            <div className="control-value">{theme.volume}%</div>
          </div>
        </div>
      </main>

      <div className="mode-display">
        <span className="mode-indicator" />
        <p className="mode-text">{theme.isDark ? 'DARK MODE' : 'LIGHT MODE'}</p>
      </div>

      <div className="quote-container">
        <p>Silence gives form to sound as darkness gives form to light.</p>
      </div>
    </div>
  )
}
